query UsersWithScopeEntities {
    users {
        id
        role {
            _id
            name
        }
        scope(getScopeEntity: true) {
            client
            campaign
            campaignOnlyClient
        }
    }
}
